import React, { useCallback, useEffect, useRef, useState } from "react";
import Icons from "../icons";

/* A notice at the top right that closes itself after a few seconds: green
   for a success (the default), red for an error. As the test suite screen's
   own (BoardDetail).

     const [showToast, toast] = useToast();
     showToast("PSR-2059 has been deleted successfully.");
     …
     {toast}                                                              */
export default function Toast({ message, kind = "success" }) {
  const error = kind === "error";
  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed right-6 top-6 z-[80] flex max-w-md items-center gap-2 rounded-lg px-4 py-3 text-sm font-medium text-white shadow-lg ring-1 ${
        error ? "bg-rose-600 ring-rose-500" : "bg-emerald-600 ring-emerald-500"
      }`}
    >
      {error ? <Icons.X className="h-4 w-4 flex-none" /> : <Icons.Check className="h-4 w-4 flex-none" />}
      <span className="min-w-0">{message}</span>
    </div>
  );
}

export function useToast(ms = 3500) {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);
  const show = useCallback(
    (message, kind = "success") => {
      clearTimeout(timer.current);
      setToast({ message, kind });
      timer.current = setTimeout(() => setToast(null), ms);
    },
    [ms],
  );
  useEffect(() => () => clearTimeout(timer.current), []);
  return [show, toast ? <Toast message={toast.message} kind={toast.kind} /> : null];
}
